import React, { memo, useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { colors, fonts, frames } from "../../../Styles";
import { SecondaryPopover, StationLoading, StationLocationVisual } from "../..";
import { currentEsfViewTypes, useEsfContext } from "../_EsfWalkThrough/EsfContext";
import { selectStationByLocationId, useStationById } from "../../../Services/Agrisys_GqlDataCaller/StationCalls/StationSlice";
import { Station } from "../../../Services/Agrisys_GqlDataCaller/StationCalls/queryStations";
import { useAttentionLog } from "../../../Services";
import { useAppSelector } from "../../../Store";

interface PenBasic_Props {
  stationId: number;
  gridArea: string;
  focus_view?: boolean;
  index: number;
  popoverContent?: JSX.Element;
  overrides?: {
    primaryColor?: colors;
    textColor?: colors;
    width?: string;
    border?: string;
    attention?: number
  }
}

export default function ESF_STATION({ stationId, index, focus_view, popoverContent, overrides }: PenBasic_Props) {
  const { t } = useTranslation();
  const {isLoading, entity: station} = useStationById(stationId);
  const { state: { selectedStations, currentStationViewType, connection, domain, system }, dispatch } = useEsfContext();
    
  // Styles
  const _primaryColor = overrides && overrides.primaryColor ? overrides.primaryColor : colors.greyLightSecondary
  const _textColor = overrides && overrides.textColor ? overrides.textColor : colors.greyDarkPrimary
  const _width = overrides && overrides.width ? overrides.width : "80px"
  const _border = overrides && overrides.border ? overrides.border : "none"
    
  // #region | Attentions
  const { data: attentionLogState, call: getAttentionLogs } = useAttentionLog(connection);

  useEffect(() => {
    if (system?.system_id) {
      getAttentionLogs({ ids: [system.system_id] })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const logData = useMemo(() => {
    if (!system) return [];
    if (domain in attentionLogState && attentionLogState[domain] && typeof attentionLogState[domain] === "object" && "data" in attentionLogState[domain] && attentionLogState[domain].data && system?.system_id) {
      return attentionLogState[domain].data.filter((log) => log.fk_systems === system?.system_id && log.dismissed !== true);
    }
    return []
  }, [attentionLogState, domain, system?.system_id])

  // Til senere: Find ud af om min section (fk_locations) er på en af terminalerne for stationen for at finde ud af om den specifikke station har en attention.
  const hasAttention = useMemo(() => overrides&&overrides.attention ? true : logData.some(data => data.fk_locations === station?.locationId), [logData, overrides, station?.locationId]);
  const penAttentionLevel = useMemo(() => overrides&&overrides.attention ? overrides.attention : logData.find(data => data.fk_locations === station?.locationId)?.level, [logData, overrides, station?.locationId])
  // const attentionOverlay = <Attention attentionLevel={penAttentionLevel} hasAttention={hasAttention} fromOverrides={overrides&&overrides.attention !== undefined ? true : false} />
  // #endregion
  
  // #region | SystemControle / On station click
  const handleClick = () => {
    const alreadySelected = selectedStations?.some((p) => p.station_id === station?.station_id);

    let newSelectedList;

    if (alreadySelected) {
      newSelectedList = selectedStations?.filter((p) => p.station_id !== station?.station_id);
    } else {
      newSelectedList = [...(selectedStations ?? []), station] as Station[];
    }

    dispatch({ selectedStations: newSelectedList });
  }
  // #endregion

  const Pen = () => {
    if (isLoading) {
      return <StationLoading/>;
    }
    if (station === undefined) {
      return <div>{"Station not found"}</div>
    }
    const gridArea = station.visual ? station.visual.replace(/^"|"$/g, '').replace(/^'|'$/g, '').split("-")[0] : ""    
    // const _popoverContent = typeof popoverContent === "function" ? popoverContent(index, station) : popoverContent ?? undefined;
    
    switch (currentStationViewType) {
      case currentEsfViewTypes.systemControle:
        return (
          <div>  
            { popoverContent ?
              <SecondaryPopover
                content={
                  <div style={{}}>
                    <StationLocationVisual isSelected={selectedStations && selectedStations.some(s => s === station)} key={station.station_id} attention={overrides && overrides.attention} onClick={handleClick} content={station?.name ?? ""} gridArea={gridArea} locationVisual={Number((station?.visual ?? "").split("-")[2])} />
                  </div>
                }
                popoverHeader=""
                popoverContent={<>{popoverContent}</>}
                overrides={{ primaryColor: colors.greyDarkPrimary }}
              />
            : <StationLocationVisual isSelected={selectedStations && selectedStations.some(s => s === station)} key={station.station_id} attention={overrides && overrides.attention} onClick={handleClick} content={station?.name ?? ""} gridArea={gridArea} locationVisual={Number((station?.visual ?? "").split("-")[2])} /> }
          </div>
        );
      case currentEsfViewTypes.attention:
        return (
          <StationLocationVisual key={station.station_id} isSelected attention={penAttentionLevel} content={station?.name ?? ""} gridArea={gridArea} locationVisual={Number((station?.visual ?? "").split("-")[2])} />
        );
      case currentEsfViewTypes.basic:
      default:
        return (
          <StationLocationVisual isSelected content={station?.name ?? ""} gridArea={gridArea} locationVisual={Number((station?.visual??"").split("-")[2])}/>
        )
    }
  }

  return Pen();
}